import { Directive, HostListener, NgModule, OnDestroy } from '@angular/core';
import { NgControl } from '@angular/forms';
import { Subject } from 'rxjs';

@Directive({
    selector: '[formControlName][appPhoneMask]',
})
export class PhoneMaskDirective implements OnDestroy {
    private destroy$ = new Subject<void>();
    constructor(public ngControl: NgControl) { }

    @HostListener('ngModelChange', ['$event'])
    onModelChange(event) {
        this.ngControl.valueAccessor.writeValue(this.onInputChange(event, false));
    }

    @HostListener('keydown.backspace', ['$event'])
    keydownBackspace(event) {
        this.ngControl.control.setValue(this.onInputChange(event.target.value, true));
    }

    onInputChange(event, backspace) {
        if(event){
        let newVal = event.replace(/\D/g, '');
        if (backspace && newVal.length <= 6) {
            newVal = newVal.substring(0, newVal.length - 1);
        }
        if (newVal.length === 0) {
            newVal = '';
        } else if (newVal.length <= 3) {
            newVal = newVal.replace(/^(\d{0,3})/, '($1)');
        } else if (newVal.length <= 6) {
            newVal = newVal.replace(/^(\d{0,3})(\d{0,3})/, '($1) $2');
        } else if (newVal.length <= 10) {
            newVal = newVal.replace(/^(\d{0,3})(\d{0,3})(\d{0,4})/, '($1) $2-$3');
        } else if(newVal.length > 10){
            newVal = newVal.substring(0, 10);
            newVal = newVal.replace(/^(\d{0,3})(\d{0,3})(\d{0,4})/, '($1) $2-$3');
            this.ngControl.control.setValue(this.onInputChange(newVal, true));
        }else {
            newVal = newVal.substring(0, 10);
            newVal = newVal.replace(/^(\d{0,3})(\d{0,3})(\d{0,4})/, '($1) $2-$3');
        }
        return newVal;
        }
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.unsubscribe();
    }
}

@NgModule({
    declarations: [PhoneMaskDirective],
    exports: [PhoneMaskDirective],
})
export class PhoneMaskDirectiveModule {}
